import { render } from "./CreateByLib_Goals.vue?vue&type=template&id=d02cf0d2&scoped=true"
import script from "./CreateByLib_Goals.vue?vue&type=script&lang=js"
export * from "./CreateByLib_Goals.vue?vue&type=script&lang=js"

import "./CreateByLib_Goals.vue?vue&type=style&index=0&id=d02cf0d2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d02cf0d2"]])

export default __exports__